var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SimpleDataTable',{attrs:{"title":'Alacaklı Cari Listesi',"description":'',"dataList":_vm.top10CurrentPayeeList,"dataHeaders":_vm.top10CurrentPayeeListHeaders,"loading":_vm.top10CurrentPayeeListLoading,"pagination-status":true,"pagination-length":_vm.maxPage},on:{"page-change":_vm.handlePageChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }